function AppFooterCopyright() {
	return (
		<div className="font-general-regular flex justify-center items-center text-center">
			<div className="text-lg text-ternary-dark dark:text-ternary-light">
				&copy; {new Date().getFullYear()}
				<a
					href="https://akrealities.com"
					target="__blank"
					className="text-secondary-dark dark:text-secondary-light font-medium uppercase hover:underline hover:text-brand-600 dark:hover:text-brand-400 ml-1 duration-500"
				>
					Ibrahim Akgül · Akrealities
				</a>
			</div>
		</div>
	);
}

export default AppFooterCopyright;
